export const globalFields = {
    id: {
        name: 'id',
    },
    masterReferenceId: {
        name: 'masterReferenceId',
    },
    person: {
        id: {
            name: 'id',
            label: 'id',
            validators: {}
        },
        tags: {
            name: 'personAndPersonTags',
            label: 'Tags',
            validators: {}
        },
        firstName: {
            name: 'firstName',
            label: 'First',
            validators: {
                minlength: 2
            }
        },
        lastName: {
            name: 'lastName',
            label: 'Last',
            validators: {}
        },
        middleName: {
            name: 'middleName',
            label: 'Middle',
            validators: {}
        },
        suffix: {
            name: 'suffixId',
            label: 'Suffix',
            validators: {}
        },
        unnamed: {
            name: 'unnamed',
            label: 'Unnamed',
            validators: {}
        },
        race: {
            name: 'raceId',
            label: 'Race',
            validators: {}
        },
        sex: {
            name: 'sexId',
            label: 'Sex',
            validators: {}
        },
        gender: {
            name: 'genderIdentityId',
            label: 'Gender Identity',
            validators: {}
        },
        ethnicity: {
            name: 'ethnicityId',
            label: 'Ethnicity',
            validators: {}
        },
        dateOfBirth: {
            name: 'dateOfBirth',
            label: 'Date Of Birth',
            validators: {}
        },
        age: {
            name: 'age',
            label: 'Current Age',
            validators: {}
        },
        isJuvenile: {
            name: 'isJuvenile',
            label: 'Juvenile',
            validators: {}
        },
        deceasedOn: {
            name: 'deceasedOn',
            label: 'Deceased On',
            validators: {}
        },
        residentStatusId: {
            name: 'residentStatusId',
            label: 'Resident Status',
            validators: {}
        },
        birthCity: {
            name: 'birthCity',
            label: 'City',
            validators: {}
        },
        birthStateId: {
            name: 'birthStateId',
            label: 'State',
            validators: {}
        },
        birthCountyId: {
            name: 'birthCountyId',
            label: 'County',
            validators: {}
        },
        birthCountryId: {
            name: 'birthCountryId',
            label: 'Country',
            validators: {}
        },
        maritalStatusId: {
            name: 'maritalStatusId',
            label: 'Marital Status',
            validators: {}
        },
        socialMediaSiteId: {
            name: 'socialMediaSiteId',
            label: 'App Name',
            validators: {}
        },
        alias: {
            name: 'alias',
            label: 'Aliases',
            validators: {}
        },
        url: {
            name: 'url',
            label: 'Url',
            validators: {}
        },
        username: {
            name: 'username',
            label: 'Username',
            validators: {}
        },
        password: {
            name: 'password',
            label: 'Password',
            validators: {}
        },
        actualHeight: {
            name: 'actualHeight',
            label: 'Height (Ft. in.)',
            validators: {}
        },
        heightFrom: {
            name: 'heightFrom',
            label: 'Height From',
            validators: {}
        },
        heightTo: {
            name: 'heightTo',
            label: 'Height To',
            validators: {}
        },
        actualWeight: {
            name: 'actualWeight',
            label: 'Weight (Lb.)',
            validators: {}
        },
        weightFrom: {
            name: 'weightFrom',
            label: 'Weight From',
            validators: {}
        },
        weightTo: {
            name: 'weightTo',
            label: 'Weight To',
            validators: {}
        },
        buildId: {
            name: 'buildId',
            label: 'Build',
            validators: {}
        },
        complexionId: {
            name: 'complexionId',
            label: 'Complexion',
            validators: {}
        },
        handednessId: {
            name: 'handednessId',
            label: 'Handedness',
            validators: {}
        },
        personPhysicalFeatureCategoryId: {
            name: 'personPhysicalFeatureCategoryId',
            label: 'Type',
            validators: {}
        },
        personPhysicalFeatureNameId: {
            name: 'personPhysicalFeatureNameId',
            label: 'Code',
            validators: {}
        },
        personPhysicalFeatureLocationId: {
            name: 'personPhysicalFeatureLocationId',
            label: 'Location',
            validators: {}
        },
        personPhysicalFeatureSubClassId: {
            name: 'personPhysicalFeatureSubClassId',
            label: 'Kind',
            validators: {}
        }
    },
    address: {
        id: {
            name: 'id',
            label: 'id',
            validators: {}
        },
        primaryAddress: {
            name: 'address',
            label: 'Address',
            validators: {}
        },
    },
    // this will get moved to incidents
    incident: {
        id: {
            name: 'id',
            label: 'id',
            validators: {}
        },
        logNumber: {
            name: 'logNumber',
            label: 'Log Number',
            validators: {}
        },
        incidentReportType: {
            name: 'incidentReportType',
            label: 'Type',
            validators: {}
        },
        reportedOn: {
            name: 'reportedOn',
            label: 'Reported',
            validators: {}
        },
        occurredOn: {
            name: 'occurredOn',
            label: 'Occurred',
            validators: {}
        },
        location: {
            name: 'location',
            label: 'Location',
            validators: {}
        },
        agency: {
            name: 'agency',
            label: 'Agency',
            validators: {}
        },
        // maybe not needed
        age: {
            name: 'age',
            label: 'Age',
            validators: {}
        },
        involvement: {
            name: 'involvement',
            label: 'Involvement',
            validators: {}
        },
        linkDate: {
            name: 'associatedOn',
            label: 'Link Date',
            validators: {}
        },
        disposition: {
            name: 'disposition',
            label: 'Disposition',
            validators: {}
        },
        // make this generic and not incident related
        comment: {
            name: 'comment',
            label: 'Comment',
            validators: {}
        },
        incidentId: {
            name: 'id',
            label: 'Incident Number',
            validators: {}
        },
        tags: {
            name: 'incidentAndIncidentTags',
            label: 'Tags',
            validators: {}
        },
        level1Reviewers: {
            name: 'level1Reviewers',
            label: 'Level 1 Reviewers',
            validators: {},
        },
        level2Reviewers: {
            name: 'level2Reviewers',
            label: 'Level 2 Reviewers',
            validators: {},
        },
        level3Reviewers: {
            name: 'level3Reviewers',
            label: 'Level 3 Reviewers',
            validators: {},
        },
        level4Reviewers: {
            name: 'level4Reviewers',
            label: 'Level 4 Reviewers',
            validators: {},
        },
        level1GroupReviewers: {
            name: 'level1GroupReviewers',
            label: 'Level 1 Groups',
            validators: {},
        },
        level2GroupReviewers: {
            name: 'level2GroupReviewers',
            label: 'Level 2 Groups',
            validators: {},
        },
        level3GroupReviewers: {
            name: 'level3GroupReviewers',
            label: 'Level 3 Groups',
            validators: {},
        },
        level4GroupReviewers: {
            name: 'level4GroupReviewers',
            label: 'Level 4 Groups',
            validators: {},
        },
    },
    vehicle: {
        //example
        vehicleId: {
            name: 'id',
            label: 'Vehicle Number',
            validators: {}
        },
        tags: {
            name: 'vehicleTags',
            label: 'Tags',
            validators: {}
        },
        itemType: {
            name: 'typeId',
            label: 'Vehicle Type',
            validators: {}
        }
    },
    organization: {
        //example
        id: {
            name: 'id',
            label: 'id',
            validators: {}
        },
        name: {
            name: 'name',
            label: 'Name',
            validators: {
                required : true,
                minlength : 2,
                maxlength: 100
            }
        },
        tags: {
            name: 'organizationAndOrganizationTags',
            label: 'Tags',
            validators: {}
        },
        class: {
            name: 'organizationClassId',
            label: 'Class',
            validators: {required : true}
        },
        status: {
            name: 'organizationStatusId',
            label: 'Status',
            validators: {required : true}
        },
        agencyCode: {
            name: 'agencyCode',
            label: 'Agency Code',
            validators: {required : true}
        },
        agencyORI: {
            name: 'agencyORI',
            label: 'Agency ORI',
            validators: {required : true}
        },
        agencyType: {
            name: 'agencyTypeId',
            label: 'Agency Type',
            validators: {required : true}
        },
        judges: {
            name: 'organizationAndJudges',
            label: 'Judges',
            validators: {}
        },
        courtIdentifier: {
            name: 'courtIdentifier',
            label: 'Court ID'
        }
    },
    charging: {
        arrestNumber: {
            name: 'arrestNumber',
            label: 'Arrest Number',
            validators: {}
        },
        arrestType: {
            name: 'arrestType',
            label: 'Arrest Type',
            validators: {}
        },
        nibrsArrestType: {
            name: 'nibrsArrestType',
            label: 'Arrest Type',
            validators: {}
        },
        ticketNumber: {
            name: 'ticketNumber',
            label: 'Complaint Number',
            validators: {}
        },
        arrestDate: {
            name: 'arrestDate',
            label: 'Arrest Date & Time',
            validators: {}
        },
        arrestDisposition: {
            name: 'arrestDisposition',
            label: 'Arrest Disposition',
            validators: {}
        },
        arrestingAgency: {
            name: 'arrestingAgency',
            label: 'Arresting Agency',
            validators: {}
        },
        arrestingOfficer: {
            name: 'arrestingOfficer',
            label: 'Arresting Officer',
            validators: {}
        },
        mirandaDateAndTime: {
            name: 'mirandaDateAndTime',
            label: 'Miranda Date & Time',
            validators: {}
        },
        mirandaBy: {
            name: 'mirandaBy',
            label: 'Miranda By',
            validators: {}
        },
        impairmentType: {
            name: 'impairmentType',
            label: 'Impairment Type',
            validators: {}
        },
        bac: {
            name: 'bac',
            label: 'B.A.C',
            validators: {}
        },
        UCRCode: {
            name: 'ucrCodeId',
            label: 'UCR Code',
            validators: {}
        },
        UCRJuvenileDisposition: {
            name: 'ucrJuvenileDispositionId',
            label: 'UCR Juvenile Disposition',
            validators: {}
        },
        multipleArrest: {
            name: 'multipleArrest',
            label: 'Multiple Arrests',
            validators: {}
        },
        juvenileDisposition: {
            name: 'juvenileDisposition',
            label: 'Juvenile Disposition',
            validators: {}
        },
        resident: {
            name: 'resident',
            label: 'Resident',
            validators: {}
        },
        ageAtTimeIncident: {
            name: 'ageAtTimeIncident',
            label: 'Age at Time of Incident',
            validators: {}
        },
        sex: {
            name: 'sex',
            label: 'Sex',
            validators: {}
        },
        race: {
            name: 'race',
            label: 'Race',
            validators: {}
        },
        ethnicity: {
            name: 'ethnicity',
            label: 'Ethnicity',
            validators: {}
        },
        value: {
            name: 'value',
            label: 'Value',
            validators: {}
        },
        automaticWeapon: {
            name: 'automaticWeapon',
            label: 'Automatic Weapon',
            validators: {}
        },
        id: {
            name: 'id',
            label: 'id',
            validators: {}
        },        
        recordTypes: {
            name: 'recordTypes',
            label: 'Report Type',
            validators: {}
        },
        tags: {
            name: 'chargingTags',
            label: 'Tags',
            validators: {}
        },
        offenseTrackingNumber: {
            name: 'offenseTrackingNumber',
            label: 'Offense Tracking Number',
            validators: {}
        },
    }
};
